<template>
  <div class="help-page">
    <div
      class="help-header"
      v-if="role.indexOf('article') >-1  && path == '/home/help/articleList'"
    >
      <div class="pull-left clear-fix">
        <a href="javascript:;" :class="{'active': activeTab == 0}" @click="handleListTab">用户帮助</a>
        <a href="javascript:;" :class="{'active': activeTab == 1}" @click="handleEdit">创建帮助</a>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import ReportList from "../components/articleList.vue";
import ArticleEdit from "../components/articleEdit";
import ArticleUpdate from "../components/articleUpdate.vue";
import { htmlToTxtMixin } from "../utils/mixins.js";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "Report",
  mixins: [htmlToTxtMixin],
  data() {
    return {
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      totalItem: 10,
      activeTab: 0,
      isSave: true
    };
  },
  components: {
    ReportList,
    ArticleEdit,
    ArticleUpdate
  },
  computed: {
    ...mapGetters(["role"]),
    path() {
      return this.$route.path;
    }
  },
  methods: {
    handleListTab() {
      this.activeTab = 0;
      this.$router.push({
        path: "/home/help/articleList",
        query: {
          type: 1
        }
      });
    },
    handleEdit() {
      this.$router.push({
        path: "/home/help/articleEdit",
        query: {
          type: 1
        }
      });
    }
  }
};
</script>

<style lang="scss">
.help-page {
  width: 100%;
  height: 100%;
  padding-bottom: 100px;
  .el-button--primary {
    font-weight: normal;
  }
  .help-header {
    height: 60px;
    line-height: 60px;
    padding: 0 10px;
    background-color: #fff;
    border-bottom: 1px solid #eee;
    .clear-fix {
      margin-top: 18px;
    }
    a {
      display: block;
      float: left;
      font-size: 16px;
      padding: 0 25px;
      line-height: 24px;
      border-left: 1px solid #eee;
      &:first-child {
        border-left: 0;
      }
      &.active,
      &:hover {
        color: #ff552e;
      }
    }
    a.inactive {
      display: block;
      float: left;
      font-size: 16px;
      padding: 0 25px;
      line-height: 24px;
      color: #aaa;
      border-left: 1px solid #eee;
      &.active,
      &:hover {
        color: #aaa;
      }
    }
  }
}

.top-notice {
  background-color: #fdeed2;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/help.vue